/* eslint-disable react-native/no-inline-styles */
import React, { useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { SlCalender } from "react-icons/sl";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Card,
  Alert,
} from "react-bootstrap";

import { TbWorld } from "react-icons/tb";
import { GrLocation } from "react-icons/gr";
import { AddToCalendarButton } from 'add-to-calendar-button-react';
import { format } from 'date-fns';
import BidOnCounty from '../pdpComponents/BidOnCounty';
import CalendarOptions from './CalendarDropdown'
import { trackButtonClick } from '@/utils/analytics';
import { getPropertyURL } from '@/utils/propertyNavigation';

const ForeclosureView = ({
  eventCenterDetail,
  statusPayload,
  listingType,
  offerCenterDetail,
  propCategory,
  data,
  estimatedOpeningBid,
  propertySpecialDetails,
  status
}) => {
  const {
    venueDetails,
    eventDate,
    startDateTime,
    startOn,
    endOn,
  } = eventCenterDetail?.event;
  const showAddToCalendar = startOn && startOn > Date.now();
  const showGetDirection = venueDetails?.eventAddressLine1;
  const pdpInitData = useSelector(state => state.pdp?.pdpInitData);
  const [showBanner, setShowBanner] = useState(false);
  const countyBiddingEnabled =
    pdpInitData?.countyBiddingEnabled === 'N' ? false : true;

  const property = pdpInitData?.propertyDetails;
  const streetNumber = property?.address?.streetNumber;
  const streetName = property?.address?.streetName;
  const city = property.address?.city;
  const state = property.address?.state;
  const zip = property.address?.zip;



  let biddingStatus = '';
  let background = 'rgb(255,255,255)';

  if (statusPayload.isScheduled && eventCenterDetail) {
    biddingStatus = 'SCHEDULED';
    background = 'rgb(255,255,255)';
  } else if (statusPayload.isClearedToSell && eventCenterDetail) {
    biddingStatus = 'CLEARED TO SELL';
    background = 'rgb(255,255,255)';
  } else if (statusPayload.isPostponed && eventCenterDetail) {
    biddingStatus = 'POSTPONED';
    background = 'rgb(255,255,255)';
  } else if (statusPayload.isAuctionEventEnded && eventCenterDetail) {
    biddingStatus = 'AUCTION EVENT ENDED';
    background = 'rgb(255,255,255)';
  }
  const currencyConverter = currencyValue => {
    if (currencyValue !== undefined && currencyValue !== '') {
      if (typeof currencyValue === 'string') {
        currencyValue = Number(currencyValue);
      }
      let value = currencyValue.toFixed(1).replace(/\d(?=(\d{3})+\.)/g, '$&,');
      return '$' + value.substring(0, value.indexOf('.') + 0);
    }
    return null;
  };
  let hasValidTimer = false;
  const getPrice = () => {
    let result = {
      amount: '',
      label: '',
    };
    if (listingType === 'AUCN') {
      if (statusPayload.isUpcoming) {
        hasValidTimer = data.auctionTimeLeft !== null;
      }
      if (data.displayListPriceForAuction === 'Y') {
        result.amount = currencyConverter(data.listingPrice);
        result.label = 'Listing Price';
      } else if (data.currentHighestBid === 0) {
        result.amount = currencyConverter(data.startingBidAmount);
        result.label = 'Starting Bid';
      } else {
        result.amount = currencyConverter(data.currentHighestBid);
        result.label = 'Current Highest Bid';
      }
    } else if (listingType === 'TRNL') {
      if (
        offerCenterDetail?.currentHighestOffer !== '0' &&
        offerCenterDetail?.currentHighestOffer !== null
      ) {
        result.amount = currencyConverter(
          offerCenterDetail.currentHighestOffer,
        );
        result.label = 'Current Highest Offer';
      } else if (offerCenterDetail.listingPrice) {
        result.amount = currencyConverter(offerCenterDetail.listingPrice);
        result.label = 'Listing Price';
      } else {
        result.amount = currencyConverter(propertySpecialDetails.listingPrice);
        // result.label = 'Current Highest Bid';
        result.label = 'Starting Bid';
      }
    } else if (propCategory === 'FORECLOSURE') {
      if (estimatedOpeningBid) {
        result.amount = currencyConverter(estimatedOpeningBid);
        result.label = 'Estimated Opening Bid';
      } else {
        result.amount = 'TBD';
        // result.label = 'Starting Bid';
        result.label = 'Estimated Opening Bid';
      }
    }
    return result;
  };


  const combined = `${eventDate} ${startDateTime}`;
  const parsedDate = new Date(combined);


  const renderScheduled = () => {
    const fullAddress = `${venueDetails?.eventAddress}`;

    return (
      <Container
        bdr
        style={{
          paddingTop: 10,
          paddingLeft: 16,
          paddingRight: 16,
          paddingBottom: 30,
          marginTop: 15,
          marginBottom: 0,
        }}>



 <h4 className='text-center bid-heading-ends' style={{marginBottom:30}}>
          {biddingStatus}
        </h4>
        {!statusPayload.isPostponed && !statusPayload.isAuctionEventEnded &&

          <Row xs={12} md={12} className='pt40 prpl10 '>
            <Col xs={12} md={8}>
              <Row>
                <h5 className='pdp-bid-deposit-data fwb pl0'>
                  <SlCalender color='rgb(17, 139, 244)' size={24} />  Auction Date & Time
                  <p className='pl30 fc-data tnCAlerts'>
                    {eventDate} at {startDateTime} Local
                  </p>
                </h5>

              </Row>
            </Col>
            <Col xs={12} md={4} className='pl0'>
              {showAddToCalendar && (
                <div style={{ fontSize: 10 }}>


                  {/* <AddToCalendar
                    event={event}

                    buttonLabel="Add to My Calendar"
                    buttonTemplate={{ 'calendar-plus-o': 'left' }}
                    dropdownClass="my-custom-dropdown"
                    items={items}
                  /> */}



                  <CalendarOptions
                    id="css-part-example"
                    title={`Reminder: Foreclosure In Person Auction for ${streetNumber}, ${streetName},${city}, ${state} ${zip} `}



                    description={
                      `1.Get updates on property status:
 https://hubzu.com${getPropertyURL(`/property/${pdpInitData?.propertyDetails?.propertyId}`, propCategory, status)}

2.Location:
${venueDetails?.eventAddress || venueDetails?.eventAddressLine1 || ''}

                      `
                    }

                    location={venueDetails?.eventAddress || `${venueDetails?.eventAddressLine1 || ''}, ${venueDetails?.county || ''}`}


                    startDateTime={parsedDate || format(new Date(), 'yyyy-MM-dd')}
                    endDateTime={parsedDate || format(new Date(), 'yyyy-MM-dd')}



                    // startTime={eventDate ? format(new Date(eventDate), 'HH:mm') : '12:01'}
                    // endTime={eventDate ? format(new Date(eventDate), 'HH:mm') : '11:59'}



                    fileName="foreclosure_event"
                  />



                </div>
              )}
            </Col>
          </Row>
        }




        <Row xs={12} md={12} className='pt20 prpl10'>
          <Col xs={12} md={6}>

            <h5 className='pdp-bid-deposit-data fwb'>
              <TbWorld color='rgb(17, 139, 244)' size={24} /> County
            </h5>


          </Col>
          <Col xs={12} md={6}>
            <p className='pl10 fc-data'>
              {venueDetails?.county}
            </p>
          </Col>
        </Row>
        <Row xs={12} md={12} className='prpl10 pt10'>
          <Col xs={12} md={6}>

            <h5 className='pdp-bid-deposit-data fwb'>
              <GrLocation color='rgb(17, 139, 244)' size={24} /> Auction Address
            </h5>


          </Col>
          <Col xs={12} md={6}>
            <p className='pl10 fc-data' style={{ wordBreak: 'break-word' }}>
              {' ' + venueDetails?.eventAddress}
            </p>
          </Col>
        </Row>
          <div className="seperator prpl20"></div>


        <h1 className='text-center fc-amount'>
          {getPrice().amount}
        </h1>
        <p className='text-center bid-heading-ends-label' style={{ color: '#00000' }}>
          {getPrice().label}
        </p>


      </Container>
    );
  };

  const renderBidonCountySite = () => {
    const fullAddress = `${venueDetails?.eventAddress}`;
    return (
      <Container
        bdr
        style={{
          paddingTop: 10,
          paddingLeft: 16,
          paddingRight: 16,
          paddingBottom: 30,
          marginTop: 15,
          marginBottom: 0,
        }}>
        <p center size={16} style={{ marginBottom:30 }} lh={28} className='bid-heading-ends'>
          {biddingStatus}
        </p>


        <div />

        {!statusPayload.isPostponed && !statusPayload.isAuctionEventEnded &&
          <>
            <Row xs={12} md={12} className='pt40 prpl10 '>
              <Col xs={12} md={8}>
                <Row>
                  <h5 className='pdp-bid-deposit-data fwb pl0'>
                    <SlCalender color='rgb(17, 139, 244)' size={24} />  Auction Date & Time
                    <p className='pl30 fc-data tnCAlerts'>
                      {eventDate} at {startDateTime} Local
                    </p>
                  </h5>

                </Row>
              </Col>
              <Col xs={12} md={4} className='pl0'>
                {showAddToCalendar && (
                  <div style={{ fontSize: 10 }}>


                    {/* <AddToCalendar
                    event={event}

                    buttonLabel="Add to My Calendar"
                    buttonTemplate={{ 'calendar-plus-o': 'left' }}
                    dropdownClass="my-custom-dropdown"
                    items={items}
                  /> */}



                    <CalendarOptions
                      id="css-part-example"
                      title={`Reminder: Foreclosure In Person Auction for ${streetNumber}, ${streetName},${city}, ${state} ${zip} `}



                      description={
                        `1.Get updates on property status:
 https://hubzu.com${getPropertyURL(`/property/${pdpInitData?.propertyDetails?.propertyId}`, propCategory, status)}

2.Location:
${venueDetails?.eventAddress || venueDetails?.eventAddressLine1 || ''}

                      `
                      }

                      location={venueDetails?.eventAddress || `${venueDetails?.eventAddressLine1 || ''}, ${venueDetails?.county || ''}`}


                      startDateTime={parsedDate || format(new Date(), 'yyyy-MM-dd')}
                      endDateTime={parsedDate || format(new Date(), 'yyyy-MM-dd')}



                      // startTime={eventDate ? format(new Date(eventDate), 'HH:mm') : '12:01'}
                      // endTime={eventDate ? format(new Date(eventDate), 'HH:mm') : '11:59'}



                      fileName="foreclosure_event"
                    />



                  </div>
                )}
              </Col>
            </Row>

            <div className="seperator prpl20"></div>
          </>
        }


        <Row style={{ width: '100%', marginBottom: 22 }}>
          <div
            className='d-flex'
            style={{ marginTop: 2, marginLeft: 0, width: '30%' }}>
            <img src={'/assets/images/pdp/globe.svg'} height={20} width={20} style={{ minHeight: 20, marginRight: 5 }} alt="globe" />
            <p size={16} lh={22} className='pdp-bid-deposit-data fwb'>
              County
            </p>

          </div>
          <div
            style={{ marginTop: 0, width: '70%', textAlign: 'left' }}>
            <p
              style={{ marginTop: 5, marginRight: 0 }}
              className='fc-data'
              size={14}
              lh={20}>
              {' '}
              {venueDetails?.county}
            </p>
          </div>
        </Row>
        <Row style={{ width: '100%', marginBottom: 20 }}>
          <div
            className='d-flex'
            style={{ marginTop: 2, marginLeft: 0, width: '30%' }}>
            <img src={'/assets/images/pdp/direction.svg'} height={20} width={20} style={{ minHeight: 20, marginRight: 5 }} alt="globe" />
            <p size={16} lh={22} className='pdp-bid-deposit-data fwb'>
              Auction Address
            </p>

          </div>

          {/* <div
            style={{ marginTop: 5, marginLeft: 0, width: '30%' }}>

            <p size={16} lh={20} className='pdp-bid-deposit-data fwb'>
              Auction Address
            </p> */}
          {/* <p
              size={12}
              lh={18}
              color={'rgb(72,82,91)'}
            >
              Auction starts in:
            </p> */}
          {/* </div> */}
          <div
            style={{ marginTop: 0, width: '70%', textAlign: 'left' }}>
            {/* <p
                style={{ marginTop: 5, marginRight: 60 }}
                size={16}
                lh={22}>
                {venueDetails?.eventAddress}
              </p> */}

            {<div className='fc-data' dangerouslySetInnerHTML={{ __html: venueDetails?.eventAddress }} />}



          </div>
        </Row>
        <div className="seperator prpl20"></div>

        <h2
          center
          size={48}
          lh={36}
          className='bid-heading-ends-offer fs-42'
          color={'rgb(72,82,91)'}
          style={{ marginTop: 3 }}>
          {getPrice().amount}
        </h2>
        <p
          center
          size={16}
          lh={28}
          className='text-center bid-heading-ends-label'
          style={{ color: '#00000', marginTop: 3 }}>

          {getPrice().label}
        </p>
        <Row style={{ marginTop: 12, marginBottom: 20 }}>
          <div className="pt20">
            <button
              className="btn btn-thm center col-12 p-2"
              type=""
              onClick={() => {
                setShowBanner(true)
                trackButtonClick({
                  eventName: "bid_at_county_pdp_click",
                  eventCategory: "NEW-PDP"
                })
              }}
            >
              {"Bid on county site"}
            </button>
          </div>

        </Row>
      </Container>
    );
  };

  const renderOtherStatus = () => {
    const fullAddress = `${venueDetails?.eventAddress}`;
    return (
      <Container
        style={{
          backgroundColor: 'rgb(252,240,215)',
          paddingTop: 28,
          paddingLeft: 16,
          paddingRight: 16,
          paddingBottom: 20,
        }}>
        <p size={16} style={{ marginBottom: 8 }}>
          Auction Scheduled
        </p>
        <Row>
          <p size={12} lh={12} ls={0.2} style={{ marginRight: 2 }}>
            Date:
          </p>
          <p size={12} lh={12} ls={0.2}>
            {eventDate}
          </p>
        </Row>
        <Row>
          <p size={12} lh={12} ls={0.2} style={{ marginRight: 2 }}>
            Start Time:
          </p>
          <p size={12} lh={12} ls={0.2}>
            {startDateTime}
          </p>
        </Row>
        <Row>
          <p size={12} lh={12} ls={0.2} style={{ marginRight: 2 }}>
            County:
          </p>
          <p size={12} lh={12} ls={0.2}>
            {venueDetails?.county}
          </p>
        </Row>
        <Row>
          <p size={12} lh={12} ls={0.2} style={{ marginRight: 2 }}>
            Location:
          </p>
          <p size={12} lh={12} ls={0.2}>
            {venueDetails?.eventAddressLine2}
          </p>
        </Row>
        <Row>
          <p size={12} lh={12} ls={0.2} style={{ marginRight: 2 }}>
            Address:
          </p>
          <p size={12} lh={12} ls={0.2}>
            {venueDetails?.eventAddressLine1}
          </p>
        </Row>
        <Row style={{ marginTop: 12 }}>
          <AddToCalendarButton>

          </AddToCalendarButton>
          {showAddToCalendar && (
            <button
              onclick={createEvent}>

              Add To Calender
            </button>
          )}

        </Row>
      </Container>
    );
  };

  // if (statusPayload.isScheduled && eventCenterDetail) {
  if (countyBiddingEnabled === true) {
    return (
      <>
        {renderBidonCountySite()}
        <BidOnCounty showBanner={showBanner} redirectUrl={pdpInitData?.countyBiddingSite} setShowBanner={setShowBanner} propertyId={123} />
      </>
    );
  }
  return renderScheduled();

};

export default ForeclosureView;
